import extendNode from '../extendNode.mjs'
import useCatRootModuleNode from '../_CAT_ROOT_MODULE/useCatRootModuleNode.jsx'
import PropertiesPane from './PropertiesPaneCatRootPm.jsx'
import meta from './metaCatRootPm.mjs'

export default () => {
    const CatRootModuleNode = useCatRootModuleNode()

    return extendNode(CatRootModuleNode, {
        ...meta,
        PropertiesPane,

        canLinkType(map, node, type) {
            return /^(RULEMRM)$/.test(type)
        },

        //menuItemsInsertConcept(map, node) {
            //return [
                //{type: 'RULEMRM'},
            //]
        //},

        menuItemsInsertProduct(map, node) {
            return [
                {type: 'RULEMRM'},
            ]
        },
    })
}
